import { simpleClient } from 'services/apiGatewayClient';
import { IUserData } from '../../entities';

const client = simpleClient<any>();

export async function fetchUsersFromServer(url: string): Promise<IUserData[]> {
  return await client.getCollection(url).then((items): IUserData[] => {
    if (Array.isArray(items)) {
      return items.map((item): IUserData => item.entity);
    }
  });
}

export async function fetchUserFromServer(url: string): Promise<IUserData> {
  return await client.get(url).then(
    (items): IUserData => {
      return items.entity;
    },
  );
}
